import {
  boolToAdobeString,
  getCanonicalURL,
  getFriendlyName,
  getPageLanguage,
  getPageName,
} from './pageAttributes';
import trackAdobeEvent from './trackAdobeEvent';

const initPageViewEvent = async ({
  gridVersion = 'V1',
  migrated = false,
  productInstanceId = '',
  siteEditorTitle = '',
  sessionInfo,
  productDetails,
}) => {
  const eventName = 'page view';
  const {
    loginMethod = '',
    isCsr,
    isCsrRep,
    currencyCode,
    hashedUserId,
    environment,
    
  } = sessionInfo || {};
  const {
    accountId,
    userId,
    productCode,
    gridVersion: productGridVersion,
    legacyMigratedFlag,
  } = productDetails || {};

  const loginId = hashedUserId ? String(hashedUserId).toUpperCase() : '';
  const loginStatus = loginId ? 'logged in' : 'not logged in';
  const resolvedGridVersion = productGridVersion || gridVersion;
  const resolvedMigratedFlag = legacyMigratedFlag ?? migrated;

  const eventPayload = {
    eventName,
    eventType: 'custom',
    timestamp: String(Date.now()),
    attributes: {
      page: {
        canonicalURL: getCanonicalURL(),
        category: 'am',
        language: getPageLanguage(),
        currency: currencyCode || '',
        referrer: document.referrer || '',
        pageName: getPageName(siteEditorTitle),
        friendlyName: getFriendlyName(),
      },
      user: {
        loginId,
        loginMethod: loginMethod || '',
        loginStatus,
        environment: environment === 'PROD' ? 'prod' : 'qa',
        isCsr: boolToAdobeString(isCsr),
        email: '',
        phone: '',
        isCsrRep: boolToAdobeString(isCsrRep),
        accountId: accountId || '',
        userId: userId || '',
      },
      account: {
        products: [
          {
            sku: productCode || '',
            category: 'SFWebsitePackage',
            gridVersion: resolvedGridVersion,
            legacyMigratedFlag: boolToAdobeString(resolvedMigratedFlag),
            productInstanceId,
          },
        ],
      },
    },
  };

  await trackAdobeEvent(eventPayload);
};

export default initPageViewEvent;
